import CreateCampaignWidgetWidgetModal from './CreateCampaignWidgetWidgetModal';

export default CreateCampaignWidgetWidgetModal;
